<template>
    <div>
        <button type="button" @click="insertHeading">H1</button>
        <button type="button" @click="insertHeading">H2</button>
        <button type="button" @click="insertHeading">H3</button>
        <button type="button" @click="insertHeading">H4</button>
        <button type="button" @click="insertHeading">H5</button>
        <button type="button" @click="insertHeading">H6</button>
    </div>
</template>

<script>
export default {
    title: 'headings',
    description: 'Headings (h1-h6)',
    icon: 'Heading',

    methods: {
        insertHeading(e) {
            this.$emit('exec', 'formatBlock', e.target.textContent);
            this.$emit('close');
        },
    },
};

</script>
